import { Box, Flex, Heading, Icon, Text } from "@chakra-ui/react";

import { VscCircle } from "react-icons/vsc";
import { ShowListProps } from "../../@types/ShowList";
import { AlertMessage } from "../../components";
import { NO_SHOWS } from "../../constant/alertMessage";
import { AvailabilityEnum } from "../../constant/enums";
import { DateSelector } from "../DateSelector";
import ShowBox from "../ShowBox";

function ShowList({
  onDateChange,
  dateSelectorMaxDays,
  screens,
  // showDetailLink,
  has_show = true,
  dateSelectorProps,
  displayEmptyShowList,
  showListContainerProps,
  showAvailabilityTextProps,
  showAvailabilityBoxProps,
  audiShowContainerProps,
  audiBoxProps,
  audiTitleProps,
  alertMessageProps,
  showAvailabilityLegend = true,
  showTimeHeadingProps,
  showBoxWrapperProps,
}: ShowListProps) {
  return (
    <>
      {(has_show || displayEmptyShowList) && (
        <Box
          background="primary.200"
          mt="1rem"
          pt="2.5rem"
          px="1rem"
          pb="1rem"
          {...showListContainerProps}
        >
          <Flex
            mb="1rem"
            direction={{
              base: "column",
              lg: "row",
            }}
            alignItems="center"
            justifyContent="space-between"
            {...showAvailabilityBoxProps}
          >
            {showTimeHeadingProps && (
              <Heading as="h3" size="lg" {...showTimeHeadingProps}>
                Show Time
              </Heading>
            )}
            {showAvailabilityLegend && (
              <Flex
                mb={{
                  base: "1rem",
                  lg: 0,
                }}
                alignItems="center"
                gap="0.25rem"
              >
                {(
                  Object.keys(AvailabilityEnum) as Array<
                    keyof typeof AvailabilityEnum
                  >
                ).map((key, index) => (
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="bold"
                    key={`availabilty__${index}`}
                  >
                    <Box display="inline-flex">
                      <Icon
                        mb={0}
                        color={AvailabilityEnum[key]}
                        fontSize={{
                          base: "xl",
                          md: "2xl",
                        }}
                        aria-label="circle_icon"
                        as={VscCircle}
                      />
                    </Box>
                    <Text
                      fontSize={{
                        base: "xs",
                        md: "sm",
                      }}
                      mb={0}
                      textTransform="capitalize"
                      {...showAvailabilityTextProps}
                    >
                      {key.toString().replaceAll("_", " ").toLowerCase()}
                    </Text>
                  </Flex>
                ))}
              </Flex>
            )}
            <DateSelector
              noOfDays={dateSelectorMaxDays}
              onDateChange={onDateChange}
              {...dateSelectorProps}
            />
          </Flex>
          {(screens.length === 0 ||
            screens.every((screen) => screen.shows.length === 0)) && (
            <AlertMessage message={NO_SHOWS} {...alertMessageProps} />
          )}

          <Flex direction="column" gap="1rem">
            {screens.map(
              (screen, index) =>
                (screen.shows.length > 0 || displayEmptyShowList) && (
                  <Flex
                    backgroundColor="blackAlpha.100"
                    borderRadius="10px"
                    overflow="hidden"
                    key={`screen__${index}`}
                    alignItems="stretch"
                    gap="1rem"
                    direction={{
                      base: "column",
                      md: "row",
                    }}
                    {...audiShowContainerProps}
                  >
                    <Box
                      width={{
                        base: "100%",
                        md: "max-content",
                      }}
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      textAlign="center"
                      background="primary.500"
                      color="white"
                      p="1.5rem"
                      px="1.5rem"
                      minW={"250px"}
                      {...audiBoxProps}
                    >
                      <Heading as="h4" size="md" {...audiTitleProps}>
                        {screen.name}
                      </Heading>
                      <Text>{screen.location}</Text>
                    </Box>
                    <Flex
                      p="1rem"
                      wrap="wrap"
                      alignItems={{
                        base: "center",
                        md: "flex-start",
                      }}
                      flex={1}
                      gap="1rem"
                      {...showBoxWrapperProps}
                    >
                      {screen.shows.length > 0 ? (
                        screen.shows.map((show, showIndex) => (
                          <ShowBox key={`show_box__${showIndex}`} {...show} />
                        ))
                      ) : (
                        <Text textColor={"red"}>
                          No shows available for this screen.
                        </Text>
                      )}
                    </Flex>
                  </Flex>
                ),
            )}
          </Flex>
        </Box>
      )}
    </>
  );
}

export default ShowList;
